module.exports = __webpack_public_path__ + "assets/9cb0ef1ee2eb4279c5c0a1892d2c3873.png";